import { CoopCodeComboBoxModel } from '../coop-code-combo-box.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 会員生協情報リストを取得する
 *
 * @export API通信成功時の処理
 * @class GetCoopListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCoopListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: CoopCodeComboBoxModel;
  private successFunc: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param {CoopCodeComboBoxModel} model
   * @param {() => void} [successFunc=null] 成功時後続処理
   * @memberof GetCoopListService
   */
  execute(model: CoopCodeComboBoxModel, successFunc: () => void = null) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('KYMW02getCoopList', new PlessRequest());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCoopListService
   */
  success(data: any) {
    this.model.updateCoopList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}
